import { ResolvedTypography } from "@core/data/types/advanced-report";

/**
 * Forces a Chart.js v3 options tree onto the report font FAMILY (size/weight are left to each
 * element's own defaults).
 *
 * Per-element fonts (title, legend, ticks, point labels, axis titles) resolve against the GLOBAL
 * `Chart.defaults.font`, not the instance's `options.font` — so the family must be written onto each
 * scope explicitly or those texts keep the default typeface.
 */
export function applyChartTypography(options: any, typography: ResolvedTypography): any {
    if (!options || !typography || !typography.fontFamily) return options;

    const family = typography.fontFamily;
    const withFamily = (target: any) => ({ ...(target || {}), font: { ...((target && target.font) || {}), family } });

    options.font = { ...(options.font || {}), family };

    options.plugins = options.plugins || {};
    options.plugins.legend = options.plugins.legend || {};
    options.plugins.legend.labels = withFamily(options.plugins.legend.labels);
    if (options.plugins.title) options.plugins.title.font = { ...(options.plugins.title.font || {}), family };
    if (options.plugins.tooltip) {
        options.plugins.tooltip.titleFont = { ...(options.plugins.tooltip.titleFont || {}), family };
        options.plugins.tooltip.bodyFont = { ...(options.plugins.tooltip.bodyFont || {}), family };
    }

    if (options.scales) {
        Object.keys(options.scales).forEach(key => {
            const scale = options.scales[key] = options.scales[key] || {};
            scale.ticks = withFamily(scale.ticks);
            scale.pointLabels = withFamily(scale.pointLabels); // radial scales; ignored elsewhere
            if (scale.title) scale.title.font = { ...(scale.title.font || {}), family };
        });
    }

    return options;
}
